export default __webpack_public_path__ + "static/media/plus-solid.b59f1db3.svg";